import { useEffect, useRef, useState } from "react";

import { cn } from "@/lib/utils";

import { DRAWER_WIDTH } from "./drawerWidth";

import "../ReviewQueue/reviewMotion.css";
import {
  ReviewDrawerBody,
  type ReviewDrawerBodyProps,
} from "./ReviewDrawerBody";

const CLOSE_MS = 150;

export function ReviewDrawer({
  current,
}: {
  current: ReviewDrawerBodyProps | null;
}) {
  const last = useRef(current);
  if (current) last.current = current;
  const isOpen = current !== null;
  const [gone, setGone] = useState(!isOpen);
  useEffect(() => {
    if (isOpen) {
      setGone(false);
      return;
    }
    const timer = setTimeout(() => setGone(true), CLOSE_MS);
    return () => clearTimeout(timer);
  }, [isOpen]);
  const shown = current ?? last.current;
  if (!shown || (gone && !isOpen)) return null;
  const label = String(shown.row.sourceAttribute ?? shown.row.id ?? "");
  return (
    <div
      role="region"
      aria-label={`Review ${label}`}
      className={cn(
        "review-drawer fixed inset-y-0 right-0 z-40 flex max-w-full flex-col border-l border-slate-200 bg-white shadow-2xl dark:border-slate-800 dark:bg-slate-900",
        DRAWER_WIDTH,
        !current && "review-drawer-closing",
      )}
    >
      <ReviewDrawerBody key={String(shown.row.id)} {...shown} />
    </div>
  );
}
